import { Component } from '@angular/core';
import { DroneModelBaseComponent } from '../drone-model-base';

@Component({
  selector: 'app-drone-model-scorpion',
  templateUrl: './drone-model-scorpion.component.html',
  styleUrl: './drone-model-scorpion.component.scss',
  standalone: false,
})
export class DroneModelScorpionComponent extends DroneModelBaseComponent {
  getConfigurationType(): string[] {
    return ['scorpionR24', 'scorpionR25'];
  }
}
